<script setup lang="ts">

import {ExtendedProject, Subscription} from "@/types";
import DeleteSubscriptionDialog from "@/Pages/projects/active_subscriptions/components/DeleteSubscriptionDialog.vue";
import {router} from "@inertiajs/vue3";
import {route} from "ziggy-js";

interface Props {
    project: ExtendedProject,
    subscriptions: Array<Subscription>,
}
const props = defineProps<Props>()
</script>

<template>
    <v-list
        v-if="subscriptions.length > 0"
        density="compact"
        class="border mt-3 py-0"
        rounded="lg"
    >
        <v-list-item
            v-for="subscription in subscriptions"
            :key="subscription.id"
            class="border-b py-2 px-3"
        >
            <template #prepend>
                <div v-if="subscription.is_active">
                    <v-icon
                        color="success"
                        class="mr-2"
                    >
                        mdi-check
                    </v-icon>
                    <span class="text-grey-darken-3 text-caption">Active</span>
                </div>
                <div v-if="!subscription.is_active">
                    <v-icon
                        color="grey-darken-3"
                        class="mr-2"
                    >
                        mdi-circle-medium
                    </v-icon>
                    <span class="text-grey-darken-3 text-caption">Inactive</span>
                </div>
            </template>
            <v-list-item-title class="text-body-2 font-weight-regular pl-10">
                {{ subscription.email }}
            </v-list-item-title>
            <template #append>
                <v-list-item-action>
                    <default-btn
                        size="small"
                        class="border font-weight-medium mr-1"
                        rounded="lg"
                        @click="router.visit(route('projects.subscriptions.edit', {project: props.project.slug, active_subscription: subscription.id}))"
                    >
                        Edit
                    </default-btn>
                    <delete-subscription-dialog
                        :project="props.project"
                        :subscription="subscription"
                    />
                </v-list-item-action>
            </template>
        </v-list-item>
    </v-list>
</template>

<style scoped>

</style>
